export const IMAGE_BB_KEY = "9ddb0ca249618eed0af3ca818a61f2db";
export const PAYMENT_KEY =
  "pk_test_51IhEkTGGYgqJx7tXy3ya34rI3Zy3TimYuILykpS9i78KrkyaufS8xvO85VhAmBiA0LneNVibJ1hlqgVrRYkWWzlP00qMnLwntJ";

export const YOUR_SERVICE_ID = "service_q7j7d6d";
export const YOUR_TEMPLATE_ID = "template_wipdsgd";
export const YOUR_USER_ID = "user_JaVs2qvpvQogZFjKfZ91f";
